<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-col class="pa-0">
        <v-sheet>
            <v-row
                no-gutters
                class="fill-height"
            >
                <v-col class="shrink">
                    <v-row no-gutters>
                        <CalendarDatePicker
                            :key="selected_date"
                            :value="[startOfSelectedWeek, endOfSelectedWeek]"
                            @input="onDatePickerInput"
                        />
                    </v-row>
                    <v-row
                        no-gutters
                        class="caption g5--text px-5"
                    >
                        <v-col cols="12">{{ current_friendly_month }}</v-col>
                        <v-col cols="12">
                            <a
                                class="g5--text"
                                :href="HelpModule.getHelpLink(HELP_LINKS.EMPLOYMENT_FUND)"
                                target="_blank"
                            >
                                <span class="mr-1">{{ $t("Workdays") }}</span>
                                <span class="mr-1">{{ month_info.work_days }},</span>
                                <span class="mr-1">{{ $t("Workhours") }}</span>
                                <span class="mr-1">{{ month_info.work_hours }}</span>
                            </a>
                        </v-col>
                    </v-row>
                    <v-row
                        v-if="$route.name === 'dashboard'"
                        no-gutters
                        class="body-2 grey--text text--darken-4 font-weight-medium px-1 py-3"
                    >
                        <v-btn
                            text
                            class="text-none body-2 font-weight-medium pl-4"
                            small
                            block
                            @click="onTodayNavClick"
                        >
                            <v-row
                                justify="start"
                                no-gutters
                            >
                                <span>{{ $t("Today") }}</span>
                            </v-row>
                        </v-btn>
                        <v-btn
                            text
                            class="text-none body-2 font-weight-medium pl-4"
                            small
                            block
                            @click="onWeekNavClick(-1)"
                        >
                            <v-row
                                justify="start"
                                no-gutters
                            >
                                <span>{{ $t("Last week") }}</span>
                            </v-row>
                        </v-btn>
                        <v-btn
                            text
                            class="text-none body-2 font-weight-medium pl-4"
                            small
                            block
                            @click="onWeekNavClick(0)"
                        >
                            <v-row
                                justify="start"
                                no-gutters
                            >
                                <span>{{ $t("This week") }}</span>
                            </v-row>
                        </v-btn>
                        <v-btn
                            text
                            class="text-none body-2 font-weight-medium pl-4"
                            small
                            block
                            @click="onWeekNavClick(1)"
                        >
                            <v-row
                                justify="start"
                                no-gutters
                            >
                                <span>{{ $t("Next week") }}</span>
                            </v-row>
                        </v-btn>
                    </v-row>
                    <!--insert filterbar here-->

                    <v-row
                        v-if="$route.name !== 'dashboard'"
                        no-gutters
                    >
                        <v-row>
                            <v-col
                                cols="12"
                                class="pt-0"
                            >
                                <dropdown
                                    :items="weekOptions"
                                    :selected="weekOptions.filter(x => calendarWeeks === x.value)"
                                    :label="$t('Weeks')"
                                    :searchable="false"
                                    open-on-right
                                    name-key="name"
                                    value-key="value"
                                    show-selected-first
                                    @input="onChangeWeeks($event.value)"
                                >
                                    <template #default="{ on }">
                                        <FilterSelectButton
                                            :on="on"
                                            icon="LayoutGrid"
                                            show-label
                                            full-width
                                            custom-style="margin: 0px 20px 0px 20px"
                                            :label="weekOptions.find(x => calendarWeeks === x.value).name"
                                        />
                                    </template>
                                </dropdown>
                            </v-col>
                        </v-row>
                        <NewFilterBar
                            :show-label-count-from="'0'"
                            custom-filter-style="margin: 0px 20px 0px 20px"
                            custom-slot-style="margin: 0px 20px 0px 20px"
                            full-width-filters
                            menu-open-right
                            :available-filters="filterHelper.getAvailableFilters()"
                            :before-route-change="filterHelper.setFilterParamsIfEmpty.bind(filterHelper)"
                            @route_change="debouncedFetchCalendarData"
                            @removing_filter="removingFilter($event)"
                            @before_filter_input="filterHelper.resetFiltersOnAccountChange($event)"
                        >
                            <template v-slot:below="{filters, filterAdd}">
                                <AddFilterButton
                                    :filters="filters"
                                    @add_filter="addingFilter($event, filterAdd)"
                                />
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <icon-button
                                            :on="on"
                                            icon="Delete"
                                            @click="filterHelper.resetFilters()"
                                        />
                                    </template>
                                    {{ $t('Clear filters') }}
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <icon-button
                                            :on="on"
                                            :disabled="Object.keys($route.query).length < 1"
                                            icon="Save"
                                            @click="onSaveFiltersClick"
                                        />
                                    </template>
                                    {{ $t('Save filters') }}
                                </v-tooltip>
                            </template>
                        </NewFilterBar>
                        <v-expansion-panels accordion>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <div class="text-subtitle-2 font-weight-medium">
                                        {{ $t('Settings') }}
                                    </div>
                                    <div
                                        v-if="canAddCompanyEvent"
                                        class="d-flex justify-end"
                                    >
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <icon-button
                                                    :on="on"
                                                    icon="Plus"
                                                    @click.stop="onOpenCalendarModal()"
                                                ></icon-button>
                                            </template>
                                            <span>{{ $t('Add company event') }}</span>
                                        </v-tooltip>
                                    </div>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <div
                                        v-for="(setting, index) in calendarSettings"
                                        :key="setting.value"
                                        class="d-flex align-center"
                                    >
                                        <checkbox
                                            class="mt-1 mb-1 pt-0"
                                            :value="current_account.data[setting.value]"
                                            color="n3"
                                            :label="setting.name"
                                            @change="onChangeCalendarSetting(setting.value, $event)"
                                        />
                                        <template v-if="setting.showGroup">
                                            <v-spacer/>
                                            <dropdown
                                                :items="settingsGroupItems"
                                                :selected="settingsGroupItems.filter(x => x.value === (current_account.data[setting.value + '_group'] ? 1 : 0))"
                                                name-key="name"
                                                value-key="value"
                                                :searchable="false"
                                                @input="onChangeCalendarSetting(setting.value + '_group', $event.value)"
                                            >
                                                <template #default="{ on }">
                                                    <icon-button
                                                        :on="on"
                                                        button-small
                                                        icon-size="20"
                                                        icon="ChevronRight"
                                                    />
                                                </template>
                                            </dropdown>
                                        </template>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-row>
                </v-col>
                <v-col>
                    <v-row no-gutters>
                        <v-col
                            v-for="(week, index) in currentWeeks"
                            :key="'week_' + week"
                            cols="12"
                            :style="
                                fullScreen
                                    ? 'height: calc(' +
                                        100 / currentWeeks +
                                        'vh - ' +
                                        56 / currentWeeks +
                                        'px); max-height: calc(' +
                                        100 / currentWeeks +
                                        'vh - ' +
                                        56 / currentWeeks +
                                        'px;)'
                                    : 'height:' + 440 * currentWeeks + 'px;'
                            "
                            :class="index === 0 ? 'first-week-list' : ''"
                        >
                            <v-calendar
                                ref="calendar"
                                class="v-dashboard-calendar"
                                interval-count="1"
                                interval-minutes="1440"
                                interval-height="min-content"
                                :value="addWeeks(selected_date, index)"
                                event-overlap-mode="column"
                                color="primary"
                                :locale="locale"
                                type="week"
                                event-overlap-threshold="0"
                                :class="[calendarClasses, index === 0 ? 'first-calendar' : '']"
                                :weekdays="weekdays"
                                @click:day="onDayClick"
                                @click:date="onDateClick"
                            >
                                <template v-slot:day-label-header="{ date }">
                                    <div v-if="getWeekDayFormat(date)"
                                         class="caption g4--text text-uppercase ml-3 pt-3">
                                        {{ getWeekDayFormat(date) }}
                                    </div>
                                    <v-spacer/>

                                    <div class="day-label-header"
                                         :class="[showDateProgressBar(date) ? 'show-progress' : '',
                                                  getDateProgressTotal(date) >= 97 ? 'time-fully-tracked' : '']">
                                        <v-avatar class="transition-ease-in-out"
                                                  :color="showSelection && isSameDate(date, selected_date) ? 'primary' : ''"
                                                  size="48">
                                            <span class="headline"
                                                  :class="showSelection && isSameDate(date, selected_date)? 'white--text' : isItemOnWeekend(date) ? 'g4--text' : 'main--text'">
                                                {{ Number(date.split("-")[2]) }}
                                            </span>
                                        </v-avatar>

                                        <div
                                             class="expected-tracked-container"
                                             :style="hasExpectedDuration(date, false) && estimation_total_list[date] ? 'margin-left: -12px;' : 'margin-left: -2px'"
                                             :class="showDateProgressBar(date) ? 'show-background' : ''">

                                            <div v-if="getDateProgressTotal(date) > 1"
                                                 class="tracked-background transition-ease-in-out"
                                                 :style="getDateProgressTotal(date) ? `width: ${getDateProgressTotal(date)}%` : null"/>

                                            <v-tooltip v-if="hasExpectedDuration(date, false)" bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <span style="z-index: 1; font-size: 12px !important;"
                                                          class="grey--text body-2 font-weight-medium"
                                                          v-on="on"
                                                          @click="openReportTrackedTime(date)">
                                                        <span v-if="getDateTotal(date)" class="main--text">{{ format_time_from_seconds(getDateTotal(date), false) }}</span>
                                                        <span v-if="getDateTotal(date) && flextimeResult && getDateExpected(date)">
                                                            /
                                                        </span>
                                                        <span
                                                            v-if="flextimeResult && getDateExpected(date)"
                                                            :class="showDateProgressBar(date) ? '' : 'g3--text'"
                                                        >
                                                            {{ format_time_from_seconds(getDateExpected(date), false) }}
                                                        </span>
                                                        <span v-else>-</span>
                                                    </span>
                                                </template>
                                                {{ $t("Tracked time") }} / {{ $t("Expected") }}
                                            </v-tooltip>
                                            <v-tooltip v-if="(estimation_total_list[date])" bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <span style="z-index: 1; font-size: 12px !important;"
                                                          class="grey--text body-2 font-weight-medium"
                                                          v-on="on"
                                                          @click="openReportEstimated(date)">
                                                        <template v-if="!hasExpectedDuration(date, false)">
                                                            <span v-if="getDateTotal(date)" class="main--text">{{ format_time_from_seconds(getDateTotal(date), false) }}</span>
                                                        </template>
                                                        <template v-if="!hasExpectedDuration(date, false) && getDateTotal(date) && estimation_total_list[date]">
                                                            /
                                                        </template>
                                                        <span v-if="estimation_total_list[date]">{{ format_time_from_seconds(estimation_total_list[date], false) }}</span>
                                                        <span v-else>-</span>
                                                    </span>
                                                </template>
                                                {{ hasExpectedDuration(date, false) ? $t("Estimation") : `${$t("Tracked time")} / ${$t("Estimation")}` }}
                                            </v-tooltip>
                                        </div>
                                    </div>

                                </template>
                                <template v-slot:interval="{ date }">
                                    <span @click="onEmptyClick(date)">
                                        <draggable
                                            :key="date"
                                            v-model="tasksByDate[date]"
                                            :options="{ group: 'tasks' }"
                                            style="min-height: 100%"
                                            draggable=".drag-item"
                                            ghost-class="ghost"
                                            @input="onDragInput($event, date)"
                                            @add="onDragAdd($event, date)"
                                        >
                                            <template slot="header">
                                                <CalendarEvents
                                                    v-if="groupedEvents.get(date)"
                                                    :events="groupedEvents.get(date)"
                                                    @edit-company-event="onOpenCalendarModal($event, 'edit')"
                                                />
                                            </template>
                                            <CalendarTask
                                                v-for="(task, task_index) in tasksByDate[date]"
                                                v-show="doesTaskListContainOnlyFinishedTasks(task.depends_on_items)"
                                                :key="date + '_' + task_index"
                                                :task="task"
                                                class="drag-item"
                                            />
                                        </draggable>
                                    </span>
                                </template>
                            </v-calendar>
                        </v-col>
                    </v-row>
                </v-col>
                <CompanyCalendarEventModal
                    v-if="isModalVisible"
                    :calendar="selectedCalendar"
                    can-select-company
                    @update="fetchCalendarData"
                    @close="closeCalendarModal"
                />
            </v-row>
        </v-sheet>
    </v-col>
</template>

<script>
import Vue from "vue";
import {ref, watch, computed, onUnmounted} from "@vue/composition-api";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import TaskModule from "../../store/modules/task";
import CalendarEventModule from "../../store/modules/calendar_event";
import DialogModule from "../../store/modules/dialog";
import AccountModule, {actions as accountModule} from "../../store/modules/account";
import AppModule from "../../store/modules/app";
import {customGroupFunction, deepClone} from "../../helpers/helpers";
import {format_time_from_seconds} from "../../helpers/formatting";
import {
    parseSysDate,
    formatTime,
    parseSysDateTime,
    parseSysTime,
    formatDateCustom,
    calcDateEquals,
    formatSysDateTime, formatDate, CustomFormats, formatSysDate
} from '../../plugins/formatting'
import {$t} from "@/i18n";

import draggable from "vuedraggable";
import CalendarTask from "./CalendarTask";
import CalendarDatePicker from "./CalendarDatePicker";
import NewFilterBar from "../../components/NewFilterBar";
import {getFilterHelper} from "@/components/NewFilterBar/FilterBar";
import TopicModule from "@/store/modules/topic";
import ClientModule from "@/store/modules/client";
import UserModule from "@/store/modules/user";
import {debounce} from "throttle-debounce";
import AddFilterButton from "@/components/NewFilterBar/components/AddFilterButton";
import BookmarkModule from "@/store/modules/bookmark";
import HelpModule from "@/modules/help/help";
import {HELP_LINKS} from "@/helpers/constants";
import {getEndOfWeek} from '@/helpers/helpers';
import FilterSelectButton from "@/components/ModernFilterBar/components/FilterSelectButton.vue";
import ProjectModule from '@/store/modules/project'
import CompanyCalendarEventModal from "../../components/Calendar/CompanyCalendarEventModal/Index.vue";
import RightsModule from "@/composables/use-rights";
import CalendarEvents from "@/views/Calendar/CalendarEvents.vue";
import ApiTimeEntry from "@/api/time_entry/timeEntry";
import TimerModule from "@/store/modules/timer";
import TaskWsModule from "@/store/modules/task_ws";

export default {
    name: "Calendar",
    components: {
        CompanyCalendarEventModal,
        FilterSelectButton, CalendarTask, CalendarDatePicker, draggable, NewFilterBar, AddFilterButton, HelpModule,
        CalendarEvents
    },
    props: {
        showSelection: {
            type: Boolean
        },
        fullScreen: {
            type: Boolean
        },
        isVisible: {
            type: Boolean,
            default: true
        }
    },
    setup(props, ctx) {
        const {can_edit_account} = RightsModule();
        const {setDialogOptions, openDialog} = DialogModule();
        const {
            available_accounts,
            current_account,
            putAccountSetup,
            isFeatureEnabledAnywhere,
            available_company_accounts,
            isFeatureEnabled,
        } = AccountModule();
        const {calendarWeeks, formatting} = AppModule();
        const dialogModule = DialogModule();
        const {events, fetchCalendarPeriod} = CalendarEventModule();
        const {projectsList, projectsFetched, fetchProjects, projectStatuses, setProjectsFetched} = ProjectModule();
        const {
            selected_date,
            selected_date_scope,
            startOfSelectedWeek,
            calendar_tasks,
            reorderCalendarTasks,
            saveTaskField,
            fetchMonthInfo,
            fetchTasks,
            fetchTaskOrders,
            clearTasks,
            openTask
        } = TaskModule();
        const {fetchAllTopics, merged_topics} = TopicModule();
        const {fetchVisibleClients, clients} = ClientModule();
        const {loadMembers, visibleMembers} = UserModule();
        const {addTimeEntryChangeCallback, time_entry_id: runningTimeEntryId, start: runningTimeEntryStart, running_duration, ticking_duration} = TimerModule();

        const estimation_total_list = computed(() => {
            const totalEstimations = {}

            if (!tasksByDate.value) {
                return totalEstimations
            }

            for (const date of Object.keys(tasksByDate.value)) {
                for (const task of tasksByDate.value[date]) {
                    if (task.estimation) {
                        if (!totalEstimations[date]) {
                            totalEstimations[date] = 0
                        }

                        totalEstimations[date] += task.estimation
                    }
                }
            }

            return totalEstimations
        })


        let promise_list = [];

        const selectedCalendar = ref(null);
        const selectedAction = ref(null);
        const isModalVisible = ref(false);

        const onOpenCalendarModal = (item, action) => {
            selectedCalendar.value = item;
            selectedAction.value = action;
            isModalVisible.value = true;
        }
        const closeCalendarModal = () => {
            isModalVisible.value = false;
            selectedCalendar.value = null;
        }

        const debouncedFetchCalendarData = debounce(300, false, query => {
            fetchCalendarData(query);
        });

        const isProjectsFetching = ref(false)
        const getProjectsForFilters = () => {
            if (!isProjectsFetching.value && !projectsFetched.value) {
                isProjectsFetching.value = true
                fetchProjects({project_status: [projectStatuses.value.active, projectStatuses.value.cancelled]}).then((data) => setProjectsFetched(true, data.items)).catch(() => setProjectsFetched(false)).finally(() => isProjectsFetching.value = false)
            }
            return projectsList.value
        }

        const filterHelper = getFilterHelper({
            filters: [
                {key: "task_status", value: [], default: true},
                {key: "topic_id_list", value: [], default: true, items: merged_topics},
                {key: "client_id_list", value: [], default: true, items: clients},
                {key: "person_id_list", value: [current_account.value.id], default: true, items: visibleMembers},
                {key: "account_id_list", value: [], items: available_accounts},
                {key: "is_important", value: ["1"]},
                {key: "is_extra", value: ["1"]},
                {key: "is_recurring", value: ["1"]},
                {key: "is_commented", value: ["1"]},
                {key: "is_tracked_time", value: ["1"]},
                {key: "is_estimated", value: ["1"]},
                {key: "follow", value: ["1"]},
                {key: "project_id_list", value: [], feature: 'project', items: getProjectsForFilters, loading: () => isProjectsFetching.value}
            ].filter(x => x.feature === undefined || isFeatureEnabledAnywhere(x.feature)),
            bookmarkType: 'calendar'
        })
        filterHelper.setFilterParamsIfEmpty()

        const initialize = async () => {
            promise_list = [fetchAllTopics()];
            promise_list.push(loadMembers(), fetchVisibleClients());
            await Promise.all(promise_list);
        };

        const currentWeeks = computed(() => {
            if (ctx.root._route.name === 'dashboard') {
                return 1
            } else {
                return calendarWeeks.value
            }
        })

        /**
         * Calendar Flextime Expected / Total
         */
        const totals = ref(null)
        const getDateTotal = (date) => {
            if (!totals.value) return null

            let total = 0
            for (const key of Object.keys(totals.value)) {
                const value = totals.value[key]
                if (value.date === date) {
                    total += value.duration
                }
            }

            const runningTimeEntryParsedStart = runningTimeEntryStart.value ? formatSysDate(parseSysDate(runningTimeEntryStart.value)) : null
            if (runningTimeEntryParsedStart === date) {
                total += running_duration.value + ticking_duration.value
            }
            return total
        }

        const flextimeResult = ref(null)

        const getDateExpected = (date, returnDefaultHours = true) => {
            const date_daily_hours = flextimeResult.value
            if (!date_daily_hours) {
                if (returnDefaultHours) {
                    return isItemOnWeekend(date) ? 0 : 8 * 3600
                } else {
                    return null
                }
            } else {
                // flextime
                if (date_daily_hours[date] === undefined || date_daily_hours[date] === null) {
                    return false
                } else {
                    return date_daily_hours[date]
                }
            }
        }

        const getDateProgressTotal = (date) => {
            const tracked = getDateTotal(date)
            if (!tracked) return 0

            const expected = getDateExpected(date)
            if (!expected) return 0

            let total = (tracked / expected) * 100
            if (total >= 97) total = 100
            return total
        }

        const isTodayPast = (date) => {
            return new Date() >= parseSysDate(date)
        }

        const hasExpectedDuration = (date, returnDefaultHours = true) => {
            return !!getDateExpected(date, returnDefaultHours)
        }

        const showDateProgressBar = (date) => {
            // has tracked time
            if (getDateTotal(date)) return true
            // has expected time
            const date_daily_hours = flextimeResult.value
            if (isTodayPast(date) && date_daily_hours && getDateExpected(date)) return true
        }
        /**
         * EOF - Calendar Flextime Expected / Total
         */

        addTimeEntryChangeCallback((timeEntry) => {
            if (!totals.value) {
                return
            }

            const newTotals = deepClone(totals.value)

            const date = formatSysDate(parseSysDate(timeEntry.start))

            if (timeEntry.is_deleted) {
                delete newTotals[timeEntry.id]
            } else {
                newTotals[timeEntry.id] = {
                    date,
                    duration: timeEntry.duration
                }
            }

            totals.value = newTotals
        })

        const endOfSelectedWeek = computed(() => {
            return getEndOfWeek(selected_date.value, currentWeeks.value);
        })

        const task_orders = ref(null);
        const month_info = ref({});
        let tasksByDate = ref({});

        const getDatesByDay = day_name => {
            const day_dates = [];
            for (let w = 0; w < currentWeeks.value; w++) {
                let sel_date = parseSysDate(selected_date.value).calcDateAdd(w, "week");
                let day_date = "";
                if (day_name == "sunday") day_date = sel_date.calcWeekEnd().formatSysDate();
                else if (day_name == "saturday")
                    day_date = sel_date
                        .calcWeekEnd()
                        .calcDateAdd(-1, "day")
                        .formatSysDate();
                else if (day_name == "monday")
                    day_date = sel_date
                        .calcWeekStart()
                        .formatSysDate();
                else {
                    console.error("Not supported");
                    day_date = sel_date.unixFmt("yyyy-MM-dd");
                }
                day_dates.push(day_date);
            }
            return day_dates;
        };
        const getTasksByDay = day_name => {
            const tasks_on_day = [];
            const dates = getDatesByDay(day_name);
            for (const date of dates) {
                if (tasksByDate.value[date] && tasksByDate.value[date].length) {
                    tasks_on_day.push(...tasksByDate.value[date]);
                }
            }
            return tasks_on_day;
        };
        const calendarClasses = computed(() => {
            return [
                Vue.formatting.first_week_day === 1 && !getTasksByDay("saturday").length ? "no-first-weekend-tasks" : "",
                Vue.formatting.first_week_day === 1 && !getTasksByDay("sunday").length ? "no-second-weekends-tasks" : "",
                Vue.formatting.first_week_day === 7 && !getTasksByDay("sunday").length ? "no-second-weekends-tasks" : "",
                Vue.formatting.first_week_day === 7 && !getTasksByDay("monday").length ? "no-first-weekend-tasks" : "",

                "first-week-day-" + Vue.formatting.first_week_day
            ];
        });

        const locale = computed(function () {
            return Vue.formatting.culture;
        });

        const addWeeks = (dt, weeks) => {
            return parseSysDate(selected_date.value)
                .calcDateAdd(weeks, "week")
                .formatSysDate();
        };
        const getDateGroupKey = task => {
            // console.log('--- --- --- getDateGroupKey task =>', task)
            // problem :: task_ws receives partial info, example start/stop has no task.date
            return (task && task.date !== undefined) ? task.date.split(" ")[0] : "0";
        };

        const prepareDatesMap = (start, end) => {
            const date_map = {};
            const dt = new Date(start);
            const end_Date = new Date(end);
            for (dt; dt <= end_Date; dt.setDate(dt.getDate() + 1)) {
                const date_str = new Date(dt).toISOString().split("T")[0];
                date_map[date_str] = [];
            }
            return date_map;
        };

        const doesTaskListContainOnlyFinishedTasks = (tasks) => {
            if (!tasks || !tasks.length) return true;

            if (showAllDependantTasksInCalendar.value) return true;

            return !tasks.find(x => x.status !== 'finished')
        }

        const groupAndSort = val => {
            // console.log('--- --- groupAndSort val =>', val)
            const tasksGroupedByDate = customGroupFunction(val, task => getDateGroupKey(task), 1, true);
            const sortingMap = {};

            task_orders.value.map(_task => {
                sortingMap[_task.date] = _task._data;
            });

            Array.from(tasksGroupedByDate.keys()).map(key => {
                /*
                 * Attach an orderIndex to each task
                 */

                tasksGroupedByDate.get(key).map((item, index) => {
                    if (!sortingMap[key]) return;

                    const orderIdMatch = sortingMap[key].indexOf(item.id.toString());
                    const orderVirtualIdMatch = sortingMap[key].indexOf(item.virtual_id.toString());

                    let value = tasksGroupedByDate.get(key)

                    if (orderIdMatch > -1) {
                        value[index].orderIndex = orderIdMatch;
                    } else if (orderVirtualIdMatch > -1) {
                        value[index].orderIndex = orderVirtualIdMatch;
                    } else {
                        value[index].orderIndex = -1;
                    }

                    tasksGroupedByDate.set(key, value)
                });
            });

            Array.from(tasksGroupedByDate.keys()).map(key => {
                /*
                 * Reorder groups
                 */

                tasksGroupedByDate.set(key, tasksGroupedByDate.get(key).sort((a, b) => {
                    if (a.orderIndex > b.orderIndex) return 1;
                    if (a.orderIndex < b.orderIndex) return -1;
                    return 0;
                }));
            });

            return tasksGroupedByDate;
        };

        watch(calendar_tasks, val => {
            if (!task_orders.value) return;
            tasksByDate.value = prepareDatesMap(startOfSelectedWeek.value, endOfSelectedWeek.value);
            tasksByDate.value = Object.assign({}, tasksByDate.value, Object.fromEntries(groupAndSort(val)));
        });

        const groupedEvents = computed(() => {
            return customGroupFunction(events.value, task => getDateGroupKey(task), 1, false, "date_from");
        });

        //visible range change
        watch(startOfSelectedWeek, val => {
            if (val && props.isVisible) {
                debouncedFetchCalendarData()
            }
        });

        const showAllDependantTasksInCalendar = ref(false);

        const taskChangeCallback = () => {
            tasksByDate.value = prepareDatesMap(startOfSelectedWeek.value, endOfSelectedWeek.value);
            tasksByDate.value = Object.assign({}, tasksByDate.value, Object.fromEntries(groupAndSort(calendar_tasks.value)));
        }

        const taskWsModule = TaskWsModule()
        taskWsModule.addTaskChangeCallback(taskChangeCallback)

        const fetchCalendarData = async function () {
            // if even single company has show dependencies, then always shown
            showAllDependantTasksInCalendar.value = available_accounts.value.some(account => {
                return account && account.data.show_all_dependant_tasks_in_calendar;
            });

            // fetch calendar tasks
            let payload = {
                meta_filter: 'calendar',
                dates_list: [startOfSelectedWeek.value, endOfSelectedWeek.value].join(","),
                date_from: startOfSelectedWeek.value,
                date_until: endOfSelectedWeek.value,
                page: 1,
                itemsPerPage: 500,
                ...filterHelper.getOnlyRelevantQueryParams()
            }
            fetchCalendarPeriod(payload)


            // fetch calendar totals
            let flextime_company_id = 0
            let flextime_country_code = ''
            let company_ids = []
            for (let i in available_company_accounts.value) {
                let company = available_company_accounts.value[i]
                company_ids.push(company.id)
                if (!flextime_company_id && isFeatureEnabled(company.id, 'flextime', false)) {
                    flextime_company_id = company.id
                    flextime_country_code = company.address_country_code
                }
            }

            let totalsPayload = {
                date_from: startOfSelectedWeek.value,
                date_until: endOfSelectedWeek.value,
                flextime_company_id: flextime_company_id,
                flextime_country_code: flextime_country_code,
                company_ids: company_ids,
            }
            const totalsResponse = await ApiTimeEntry.fetchCalendarTotals(totalsPayload)
            totals.value = totalsResponse.totals
            flextimeResult.value = totalsResponse.flextime_expected


            // fetch dashboard tasks
            if (current_account.value.data.show_tasks || ctx.root._route.name === 'dashboard') {
                fetchTaskOrders(startOfSelectedWeek.value, endOfSelectedWeek.value).then(res => {
                    task_orders.value = res;
                    // Dashboard calendar should not send task_status, should find a better way to do this
                    if (ctx.root._route.name === 'dashboard') {
                        payload['task_status'] = ''
                    }
                    fetchTasks(payload);
                });
            } else if (ctx.root._route.name === 'calendar') {
                clearTasks({calendar: true})
            }

        }

        const current_year_month = computed(() => {
            return selected_date.value.substr(0, 7);
        });

        const current_friendly_month = computed(() => {
            return formatDateCustom(parseSysDate(selected_date.value), CustomFormats.month_name_with_full_year);
        });

        watch(current_year_month, async val => {
            if (props.isVisible) {
                fetchMonthInfo(current_account.value.address_country_code, val)
                    .then(resp => (month_info.value = resp))
                    .catch(ex => errorDialog.showError(ex));
            }
        });
        const isSameDate = (date, date2) => {
            const d1 = parseSysDate(date);
            const d2 = parseSysDate(date2);
            return calcDateEquals(d1, d2, "day");
        };

        //=====================
        const onDayClick = d => {
            selected_date.value = d.date;
            selected_date_scope.value = "day";
        };
        const onDateClick = d => {
            selected_date.value = d.date;
            selected_date_scope.value = "day";
        };
        const onEmptyClick = d => {
            openTask(0, {date: d});
        };
        const onDragInput = (val, date) => {
            const sorted_task_ids_list = val.map(task => {
                return task.id ? String(task.id) : task.virtual_id;
            });
            reorderCalendarTasks({sorted_task_ids_list: sorted_task_ids_list, date});
        };
        const onDragAdd = function (val, date) {
            const total_events_count = groupedEvents.value.get(date) ? groupedEvents.value.get(date).length : 0;
            // having a header increases draggable's index by 1 not by the amount of "events" in the header
            const indexFix = total_events_count > 0 ? 1 : 0
            const moved_task = tasksByDate.value[date][val.newIndex - indexFix];

            let new_date = parseSysDate(date);
            let orig_date = moved_task.date;
            let due_date = parseSysDateTime(moved_task.due_date);

            if (due_date >= new_date || moved_task.has_due_date === 0) {
                postponeTask(moved_task, val, date, total_events_count, moved_task.has_due_date === 0);
            } else {
                let dialog_props = {
                    title: $t("Do you also want to postpone the due date?"),
                    confirm_text: $t("Yes"),
                    cancel_text: $t("Cancel"),
                    action: function () {
                        postponeTask(moved_task, val, date, total_events_count, true);
                    },
                    cancel: function () {
                        moveBack(moved_task, orig_date.substr(0, 10), date);
                    }
                };
                dialogModule.setConfirmOptions(dialog_props);
                dialogModule.openConfirmDialog();
            }
        };
        const moveBack = function (task, origDate, newDate) {
            for (let i = 0; i < tasksByDate.value[newDate].length; i++) {
                let t = tasksByDate.value[newDate][i];
                if (
                    (t.id !== null && task.id !== 0 && t.id === task.id) ||
                    (t.virtual_id != null && task.virtual_id != null && t.virtual_id === task.virtual_id)
                ) {
                    tasksByDate.value[newDate].splice(i, 1);
                    tasksByDate.value[origDate].push(t);
                    break;
                }
            }
        };
        const postponeTask = function (task, val, new_date, events_count, chn_due_date) {
            let new_datetime = "{0} {1}".format(new_date, task.date.split(" ")[1]);
            let new_due_datetime = task.due_date;

            if (chn_due_date) {
                new_due_datetime = "{0} {1}".format(new_date, task.due_date.split(" ")[1]);
            }

            task.date = new_datetime;
            task.due_date = new_due_datetime;

            let data = {
                id: task.id,
                virtual_id: task.virtual_id,
                date: new_datetime,
                due_date: new_due_datetime,
                idx: val.newIndex - events_count
            };

            saveTaskField(data, "Calendar.vue").catch(function (ex) {
                errorDialog.showError(ex);
            });
        };
        const onDatePickerInput = val => {
            selected_date.value = val;
            selected_date_scope.value = "day";
        };
        const displayFriendlyMonth = date => {
            let now = new Date();
            let d = parseSysDate(date);

            return (now.getMonth() !== d.getMonth() || now.getFullYear() !== d.getFullYear())
                ? formatDateCustom(d, CustomFormats.short_month_name)
                : null;
        };
        const onWeekNavClick = week_offset => {
            selected_date.value = new Date()
                .calcWeekStart()
                .calcDateAdd(week_offset, "week")
                .formatSysDate();
            selected_date_scope.value = "week";
        };

        const onTodayNavClick = () => {
            selected_date.value = new Date(Date.now()).formatSysDate();
            selected_date_scope.value = "day";
        };

        const {navigate_report_default_route} = BookmarkModule();
        const openReportTrackedTime = date => {
            navigate_report_default_route({
                view: "time_entries",
                dates_list: [date, date],
                person_id_list: filterHelper.getUrlParam("person_id_list") || current_account.value.id,
                account_id_list: filterHelper.getUrlParam("account_id_list") || "",
                client_id_list: filterHelper.getUrlParam("client_id_list") || "",
                topic_id_list: filterHelper.getUrlParam("topic_id_list") || "",
                task_status: currentWeeks.value === 1 ? '' : filterHelper.getUrlParam("task_status") || "",
                is_tracked_time: "1",
                // DO NOT - columns: ["topic_id", "person_id", "time", "time_period", "start"],
                // DO NOT - groupBy: props.grouping,
            });
        };

        const openReportEstimated = date => {
            navigate_report_default_route({
                view: "detailed",
                dates_list: [date, date],
                person_id_list: filterHelper.getUrlParam("person_id_list") || current_account.value.id,
                account_id_list: filterHelper.getUrlParam("account_id_list") || "",
                client_id_list: filterHelper.getUrlParam("client_id_list") || "",
                topic_id_list: filterHelper.getUrlParam("topic_id_list") || "",
                task_status: currentWeeks.value === 1 ? '' : filterHelper.getUrlParam("task_status") || "",
                columns: ["client", "title", "topic_id", "assignees", "is_extra", "is_important", "time", "estimation", "date", "due_date", "status"]
            });
        };

        const isItemOnWeekend = dateString => {
            const dayIndex = new Date(Date.parse(dateString)).getUTCDay();
            return dayIndex === 0 || dayIndex === 6
        };

        const getWeekDayFormat = (date) => {
            const parsedDate = parseSysDate(date)
            const startOfFirstWeek = parseSysDate(startOfSelectedWeek.value)
            const endOfFirstWeek = parseSysDate(getEndOfWeek(startOfSelectedWeek.value, 1))
            let output = []

            if (startOfFirstWeek <= parsedDate && parsedDate <= endOfFirstWeek) {
                const dayOfWeek = formatDateCustom(parsedDate, CustomFormats.weekday_short)
                output.push(dayOfWeek)
            }

            const friendlyMonth = displayFriendlyMonth(date)
            if (friendlyMonth) {
                output.push(friendlyMonth)
            }

            return output.join(' / ');
        };

        onUnmounted(function () {
            clearTasks({calendar: true});
        });

        const onSaveFiltersClick = () => {
            setDialogOptions({
                component: () => import("@/views/Dialog/BookmarkDialog"),
                payload: {
                    type: "calendar"
                }
            });
            openDialog();
        };

        const addingFilter = (ev, callback) => {
            if (ev.key === "follow") {
                filterHelper.setFilters({
                    person_id_list: [],
                    follow: 1
                });
                return;
            }
            callback(ev);
        };
        const removingFilter = filter_key => {
            if (filter_key === "follow") {
                filterHelper.resetFilter("person_id_list");
            }
        };

        const weekOptions = computed(() => {
            return [
                {
                    name: $t('{0} week').format(1),
                    value: 1
                },
                {
                    name: $t('{0} weeks').format(2),
                    value: 2
                },
                {
                    name: $t('{0} weeks').format(3),
                    value: 3
                },
                {
                    name: $t('{0} weeks').format(4),
                    value: 4
                },
            ]
        })

        const calendarSettings = computed(() => {
            const isMemberBirthdaysEnabledForAnyCompany = available_company_accounts.value.some(x => x.data.member_birthdays_visible)
            const isContactBirthdaysEnabledForAnyCompany = available_company_accounts.value.some(x => x.data.contact_birthdays_visible)

            return [
                {
                    value: 'show_tasks',
                    name: $t('Tasks'),
                },
                flextimeEnabled.value ? {
                    value: 'show_vacations',
                    name: $t('Vacations'),
                    showGroup: true
                } : null,
                {
                    value: 'show_holidays',
                    name: $t('Holidays')
                },
                {
                    value: 'show_tax_dates',
                    name: $t('Tax dates')
                },
                {
                    value: 'show_news',
                    name: $t('Accounting news')
                },
                {
                    value: 'show_company_calendar',
                    name: $t('Company events')
                },
                isMemberBirthdaysEnabledForAnyCompany ? {
                    value: 'show_member_birthdays',
                    name: $t('Member birthdays'),
                    showGroup: true
                } : null,
                isContactBirthdaysEnabledForAnyCompany ? {
                    value: 'show_contact_birthdays',
                    name: $t('Contact birthdays'),
                    showGroup: true
                } : null
            ].filter(x => x)
        })

        const onChangeCalendarSetting = async (key, value) => {
            try {
                let data = {...current_account.value.data}
                data[key] = value ? 1 : 0

                await putAccountSetup({
                    id: current_account.value.id,
                    append_settings: data
                })

                await debouncedFetchCalendarData()
            } catch (e) {
                errorDialog.showError(e)
            }
        }

        const onChangeWeeks = async (value) => {
            calendarWeeks.value = value

            try {
                let data = {...current_account.value.data}
                data['calendar_weeks'] = value

                await putAccountSetup({
                    id: current_account.value.id,
                    append_settings: data
                })
                await debouncedFetchCalendarData()
            } catch (e) {
                errorDialog.showError(e)
            }
        }

        const weekdays = computed(() => {
            if (Vue.formatting.first_week_day === 7) return [0, 1, 2, 3, 4, 5, 6]
            return [1, 2, 3, 4, 5, 6, 0]
        })

        const flextimeEnabled = computed(() => {
            return accountModule.isFeatureEnabledAnywhere("flextime", false);
        });

        const settingsGroupItems = computed(() => [
            {
                name: $t('Group items'),
                value: 1
            },
            {
                name: $t("Don't group"),
                value: 0
            }
        ])

        watch(() => props.isVisible, async () => {
            if (props.isVisible) {
                await initialize()

                if (ctx.root._route.name === 'dashboard') {
                    await debouncedFetchCalendarData()
                    await fetchMonthInfo(current_account.value.address_country_code, current_year_month.value)
                        .then(resp => (month_info.value = resp))
                        .catch(ex => errorDialog.showError(ex));
                }
            }
        })

        const companyAccountsWhereUserIsAdmin = computed(() => {
            return available_company_accounts.value.filter(company => {
                const currentMember = company.members.find(x => x.id === current_account.value.id)
                return currentMember && ['admin', 'owner'].includes(currentMember.role)
            })
        })

        const canAddCompanyEvent = computed(() => companyAccountsWhereUserIsAdmin.value.length > 0)

        return {
            selected_date,
            month_info,
            tasksByDate,
            events,
            startOfSelectedWeek,
            endOfSelectedWeek,
            calendarClasses,
            totals,
            estimation_total_list,
            current_friendly_month,
            format_time_from_seconds,
            addWeeks,
            isSameDate,
            onDateClick,
            onDayClick,
            onEmptyClick,
            onDragInput,
            onDragAdd,
            onDatePickerInput,
            onWeekNavClick,
            onTodayNavClick,
            displayFriendlyMonth,
            openReportTrackedTime,
            isItemOnWeekend,
            getWeekDayFormat,
            filterHelper,
            debouncedFetchCalendarData,
            fetchCalendarData,
            onSaveFiltersClick,
            addingFilter,
            removingFilter,
            HelpModule,
            HELP_LINKS,
            parseSysTime,
            formatTime,
            weekOptions,
            calendarWeeks,
            currentWeeks,
            calendarSettings,
            current_account,
            onChangeCalendarSetting,
            onChangeWeeks,
            weekdays,
            locale,
            isModalVisible,
            closeCalendarModal,
            onOpenCalendarModal,
            available_company_accounts,
            selectedCalendar,
            selectedAction,
            can_edit_account,
            groupedEvents,
            settingsGroupItems,
            canAddCompanyEvent,
            getDateExpected,
            getDateProgressTotal,
            showDateProgressBar,
            calendar_tasks,
            getDateTotal,
            running_duration,
            hasExpectedDuration,
            doesTaskListContainOnlyFinishedTasks,
            showAllDependantTasksInCalendar,
            flextimeResult,
            openReportEstimated
        };
    }
};
</script>

<style scoped lang="scss">

::v-deep .v-calendar-daily__head {
    overflow-y: scroll;
    margin-right: 0 !important;
}

::v-deep .v-calendar-daily_head-weekday {
    display: none !important;
}

::v-deep .v-calendar-daily_head-day-label {
    height: 100%;
    display: flex;
    flex-direction: column;
}

::v-deep .ghost.calendar-task-row-wrap {
    /*
     *  Increased specificity is for overriding .v-application .transparent {... !important}
     */

    border-radius: 4px;
    background-color: var(--v-n1-base) !important;
    border: 1px dashed var(--v-n3-base) !important;

    .calendar-task-row {
        visibility: hidden;
    }
}

.v-expansion-panel {
    &::before {
        content: unset !important;
    }
}

::v-deep .v-calendar-daily {
    .v-calendar-daily__day {
        border-bottom: 0 !important;
    }
}

.first-week-list {
    .v-calendar {
        border-top: 0 !important;
    }
}

.v-sheet {
    border-radius: 0;
}

.day-label-header {
    display: flex;
    align-items: center;
    padding-left: 4px;
    padding-right: 4px;
    padding-top: 4px;

    .v-avatar {
        z-index: 1;
        background: white;
    }

    .expected-tracked-container {
        position: relative;
        flex-grow: 1;
        border-radius: 0 8px 8px 0;
        margin-right: 2px;
        display: flex;
        justify-content: flex-end;
        padding-right: 8px;
        padding-left: 8px;
        overflow: hidden;
        flex-direction: column;
        align-items: flex-end;

        &.show-background {
            background: var(--v-g1-base);
        }

        .tracked-background {
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            background-color: var(--v-tretiary-lighten2);
            border: 1px solid var(--v-tretiary-lighten1);
            border-radius: 0 8px 8px 0;
        }
    }

    .v-avatar {
        border: 1px solid var(--v-g3-base);
    }

    &.time-fully-tracked {
        .v-avatar {
            border: 1px solid var(--v-tretiary-lighten1);
            background-color: var(--v-tretiary-lighten2) !important;
        }
    }
}
</style>
